module.exports = __webpack_public_path__ + "img/cooperate_qy_15@2x.ca3c395a.png";